// Routes of the camera pages (app/screens/cam). LIST is the Camera tab
// (pages/Home/Camera.js). DEVICE takes { device, accessToken, area } and VIEW
// { url, title } as location.state, as the app's CameraList and CamWebView
// take their params.
export const CAMERA_PATHS = Object.freeze({
  LIST: "/camera",
  DEVICE: "/camera/device",
  VIEW: "/camera/view",
});
